"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditableBlock;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useEditableBlockProps = _interopRequireDefault(require("../hooks/useEditableBlockProps"));

var _EditableContextMenu = _interopRequireDefault(require("./EditableContextMenu"));

var _excluded = ["content", "verbose", "options"],
    _excluded2 = ["content", "onContent", "decorators", "style", "onClick", "components", "options", "index", "verbose"],
    _excluded3 = ["editIndex", "save"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_PROPS = _objectSpread(_objectSpread({}, _useEditableBlockProps.default.defaultProps), {}, {
  style: {
    whiteSpace: 'pre-wrap',
    padding: '1em'
  },
  components: {
    block: function block(_ref) {
      var content = _ref.content,
          verbose = _ref.verbose,
          options = _ref.options,
          props = _objectWithoutProperties(_ref, _excluded);

      return /*#__PURE__*/_react.default.createElement("div", _extends({
        className: "block"
      }, props));
    }
  }
});

function EditableBlock(_ref2) {
  var content = _ref2.content,
      onContent = _ref2.onContent,
      decorators = _ref2.decorators,
      style = _ref2.style,
      onClick = _ref2.onClick,
      _components = _ref2.components,
      options = _ref2.options,
      index = _ref2.index,
      _ref2$verbose = _ref2.verbose,
      verbose = _ref2$verbose === void 0 ? false : _ref2$verbose,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var components = _objectSpread(_objectSpread({}, DEFAULT_PROPS.components), _components);

  var _ref3 = components || {},
      Block = _ref3.block; // eslint-disable-next-line react-hooks/exhaustive-deps


  (0, _react.useEffect)(function () {
    if (verbose) console.log('EditableBlock First Render');
  }, []);

  var _useEditableBlockProp = (0, _useEditableBlockProps.default)({
    content: content,
    onContent: onContent,
    decorators: decorators,
    options: options
  }),
      editIndex = _useEditableBlockProp.editIndex,
      save = _useEditableBlockProp.save,
      editableBlockProps = _objectWithoutProperties(_useEditableBlockProp, _excluded3);

  var blockProps = _objectSpread(_objectSpread({
    content: content,
    style: style,
    onClick: onClick,
    index: index,
    verbose: verbose,
    options: options
  }, editableBlockProps), props);

  return /*#__PURE__*/_react.default.createElement(Block, _extends({
    key: editIndex + content
  }, blockProps));
}

;
EditableBlock.propTypes = {
  /** Text to be edited whether file, section or block */
  content: _propTypes.default.string.isRequired,

  /** Function triggered on edit */
  onContent: _propTypes.default.func,

  /** Options for the editor */
  options: _propTypes.default.shape({
    /** Editable? */
    editable: _propTypes.default.bool,

    /** Return html instead of text */
    returnHtml: _propTypes.default.bool
  }),

  /** Components to wrap all sections of the document */
  components: _propTypes.default.shape({
    /** Component to be the block editor */
    block: _propTypes.default.func
  }),

  /** Object of replacers for html/css decoration of text */
  decorators: _propTypes.default.object,

  /** Callback triggered on Block click, provides block text and index. */
  onClick: _propTypes.default.func,

  /** css styles for the editable component */
  style: _propTypes.default.object,

  /** Index to use and reference for rendering */
  index: _propTypes.default.number,

  /** Flag to enable logging  */
  verbose: _propTypes.default.bool
};
EditableBlock.defaultProps = DEFAULT_PROPS;